import React from "react";
import { getOrderItemCustomNote } from "../helperFunctions/orderCardDataHelper";

const wrapStyle = {
  display: "flex",
  alignItems: "flex-start",
  gap: 4,
  marginTop: 4,
  maxWidth: "100%",
  fontSize: 12,
  lineHeight: 1.4,
  color: "var(--qv-text-muted, #6A6A6A)",
  textDecoration: "none",
};

const labelStyle = { flexShrink: 0, fontWeight: 600, color: "var(--qv-text, #1a1a2e)" };

const textStyle = {
  minWidth: 0,
  whiteSpace: "pre-wrap",
  overflowWrap: "anywhere",
  wordBreak: "break-word",
};

/** Renders an order line's custom_note; renders nothing when the note is missing or blank. */
function OrderItemCustomNote({ item, className = "" }) {
  const note = getOrderItemCustomNote(item);
  if (!note) return null;
  return (
    <div className={className} style={wrapStyle}>
      <span style={labelStyle}>Note:</span>
      <span style={textStyle}>{note}</span>
    </div>
  );
}

export default React.memo(OrderItemCustomNote);
